import React from 'react';
import { Route, Switch } from 'react-router-dom';
import routeConfig from './routesConfig';
import PrivateRoute from './PrivateRoute';
import LoginPage from '../Component/Login/LoginPage';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route exact path="/login" component={LoginPage} />
      {routeConfig.map(route => (
        <PrivateRoute key={route.path} {...route} />
      ))}
    </Switch>
  );
};

export default Routes;
